<script>
    import {fade} from 'svelte/transition';
    import {setFocusTo} from "../lib/lib";
    import error from '../stores/error';
    import PasswordControl from "../controls/PasswordControl.svelte";
    import {cookie} from "../lib/cookie";
    import {USER_COOKIE} from "../lib/constants";

    export let userToken = null;

    let username = '';
    let password = '';

    const login = () => {

        if (username === 'ka-tools-user' && password === 'ka-tools#2025') {
            userToken = 'z34qq34cq34cq3xc348345t34cq3x41q4345v53035ycv235c235c25c3';
                cookie.create(USER_COOKIE, userToken);
        } else {
            error.show("Λάθος!");
        }
    }

    setFocusTo('login-username');
</script>

<div class="login-overlay" transition:fade="{{ duration: 100 }}">
    <div class="login-content">
        <div class="login-inner">
            <form on:submit|preventDefault|stopPropagation="{ login }">
                <div class="form-group">
                    <input type="text" class="form-control bg-white" id="login-username" bind:value="{ username }"
                           placeholder="όνομα χρήστη"
                           required>
                </div>
                <div class="form-group">
                    <PasswordControl bind:value={password} placeholder="κωδικός" id="login-pass"/>
                </div>
                <div class="text-end">
                    <button class="btn btn-primary btn-block">ΕΙΣΟΔΟΣ</button>
                </div>
            </form>
        </div>
    </div>
</div>

<style>
    .login-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #f2f6f8;
        z-index: 9000;
    }

    .login-content {
        position: absolute;
        width: 80%;
        max-width: 250px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }

    .login-inner {
        position: relative;
        max-width: 300px;
    }

    .login-inner.error {
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .login-logo {
        margin-bottom: 20px;
    }

    .login-logo img {
        width: 100%;
    }
</style>